export const isMobile = () => {
  return window.innerWidth <= 767 && window.innerHeight <= 1024;
};
